<template>
  <div class="container-fluid mx-0">
    <div class="title-container d-flex flex-row">
      <div id="logo-container" class="d-flex flex-column align-items-center justify-content-center" height="100%">
        <img :src="clientLogo" alt="Logo" height="36" class="d-inline-block align-text-top logo" />
      </div>
      <div class="d-flex flex-column w-100">
        <div class="d-flex flex-column justify-content-between  w-100">


          <div class="d-flex flex-row justify-content-between  w-100">
            <div class="page-title mx-3 mt-3">
              <div>Crash Safety Manual</div>

            </div>
            <div id="export-date" class="mx-3 mt-3 text-black-50"><em>Exported on {{ todaysDate }}</em></div>
          </div>
          <div class="d-flex flex-row justify-content-between  w-100">
            <h1 class="mt-0 mx-3"> {{ page.name }}</h1>

            <button id="print-button" class="btn" @click="printPage()">
              <img src="/print_FILL.svg" class="print-icon" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- desktop -->
    <div class="d-sm-none d-md-block" id="desktop-hottopic">
      <div class="row pb-5">
        <div class="col" v-html="htmlContent" />
        <div class="col p-3">
          <KeyPointsCard class="pb-3" v-if="page.keyPoints" :keypoints="page.keyPoints" />
          <ScenarioAccordion v-if="page.scenarios" :scenarios="page.scenarios" />
        </div>
      </div>
    </div>
    <!-- mobile, reordering key points -->
    <div class="d-none d-sm-block d-md-none" id="mobile-hottopic">
      <div class="row pb-5">
        <div class="col mx-3">
          <AlertBar v-if="page.alert" :title="page.alert.title" :body="page.alert.body" />
          <KeyPointsCard class="pb-3" v-if="page.keyPoints" :keypoints="page.keyPoints" />
          <div class="col" v-html="htmlContent" />
          <ScenarioAccordion v-if="page.scenarios" :scenarios="page.scenarios" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ScenarioAccordion from "@/components/page_elements/ScenarioAccordion.vue";
import KeyPointsCard from "@/components/page_elements/KeyPointsCard.vue";
import AlertBar from "@/components/page_elements/AlertBar.vue";

import GDOTLogo from "/public/gdot-logo.png";
import PrintIcon from "/public/print_FILL.svg";


// Get HTML Content
async function loadPageContent(htmlFile) {
  if (!htmlFile) return "<!-- No HTML File for this page -->";

  return (await import(`@/pages/${htmlFile}`)).default;
}


export default {
  name: "PageView",
  components: {
    ScenarioAccordion,
    KeyPointsCard,
    AlertBar
  },
  props: {
    page: Object
  },
  data() {
    return {
      clientLogo: GDOTLogo,
      todaysDate: new Date().toLocaleDateString(),
      printIcon: PrintIcon,
      htmlContent: '<!-- Loading... -->'
    };
  },
  methods: {
    printPage() {
      window.print()
    }
  },
  async created() {
    this.htmlContent = await loadPageContent(this.page.htmlContent);
  },
};

</script>

<style scoped>
.title-container {
  align-items: stretch;
  justify-content: space-between;
  width: 98%;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, .25);
  ;
}

.print-icon {
  height: 50px;
}

.print-icon:hover {
  filter: contrast(0.6);
}

@media print {
  #print-button {
    display: none;
  }

  .title-container {
    justify-content: start;
  }

}

@media screen {
  #logo-container {
    display: none !important;
  }

  #export-date {
    display: none !important;
  }
}

@media screen and (max-width: 768px) {
  #desktop-hottopic {
    display: none !important;
  }

  #mobile-hottopic {
    display: block !important;
  }
}

@media screen and (min-width: 768px) {
  #desktop-hottopic {
    display: block !important;
  }

  #mobile-hottopic {
    display: none !important;
  }
}
</style>
